module.exports = __webpack_public_path__ + "img/a2-s16.1443ea97.jpg";